import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./ErpN.css";
import AspironImage from "../../assets/why choose asp.jpg";
import AdhikritImage from "../../assets/erp.jpg";
import FeaturesOfAdhikritERP from "../../assets/erp-culture.jpg";

const Erp_clients = () => {
  const [expanded, setExpanded] = useState("panel1");
  const [dashboard, setDashboard] = useState("");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null); // If expanded, set the panel, otherwise set null
  };

  return (
    <div className="main_dashboard">
      <div className="Accordion_main">
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          onClick={() => setDashboard("")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "black" }} />}
            aria-controls="panel1-content"
            id="panel1-header"
            style={{
              background: "#FF9800",
              color: "black",
              fontWeight: "bolder",
            }}
          >
            Why to choose aspiron
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0px", margin: "0px" }}>
            <ol>
              <li>
                Our team consists of experts with a deep understanding of the
                unique challenges faced by educational institutions.
              </li>
              <li>
                We thrive on innovation, constantly exploring new technologies
                and methodologies to stay at the forefront of educational
                software development.
              </li>
            </ol>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
          onClick={() => setDashboard("2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "black" }} />}
            aria-controls="panel2-content"
            id="panel2-header"
            style={{
              background: "#FF9800",
              color: "black",
              fontWeight: "bolder",
            }}
          >
            Reasons to Choose Adhikrit ERP
          </AccordionSummary>
          <AccordionDetails>
            <ol>
              <li>
                Future-Ready Technology: Stay ahead with cutting-edge features
                designed for the modern business landscape.
              </li>
              <li>
                Unparalleled Flexibility: Whether on mobile, desktop, or tablet,
                our ERP adapts to your needs effortlessly.
              </li>
            </ol>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
          onClick={() => setDashboard("3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "black" }} />}
            aria-controls="panel3-content"
            id="panel3-header"
            style={{
              background: "#FF9800",
              color: "black",
              fontWeight: "bolder",
            }}
          >
            Features of Adhikrit ERP
          </AccordionSummary>
          <AccordionDetails>
            <ol>
              <li>Academic Management</li>
              <li>Student Information System</li>
              <li>Mobile Accessibility</li>
              <li>Integrated Communication Tools</li>
              <li>User-Friendly Interface</li>
            </ol>
          </AccordionDetails>
        </Accordion>
      </div>

      <div className="DashboardiMAGE">
        {dashboard === "" && (
          <img src={AspironImage} alt="Aspiron" className="dashboardImage" />
        )}
        {dashboard === "2" && (
          <img
            src={AdhikritImage}
            className="dashboardImage"
            alt="Adhikrit ERP"
          />
        )}
        {dashboard === "3" && (
          <img
            src={FeaturesOfAdhikritERP}
            className="dashboardImage"
            alt="Features of Adhikrit ERP"
          />
        )}
      </div>
    </div>
  );
};

export default Erp_clients;
